import React from 'react'
 
import DeliverableList from './DeliverableList';
export default function TurfPlantList() {
    return <DeliverableList category="TP"/>
 
}
